var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.server)?_c('span',[_vm._v(_vm._s(_vm.serverId))]):_c('a',{attrs:{"target":"_blank","href":'https://ark.domination-gaming.com/server/' + _vm.server.id}},[_vm._v(_vm._s(_vm.server.name || _vm.server.id))])])}
var staticRenderFns = []

export { render, staticRenderFns }